export enum Cookie {
    cid = "cid",
    gclid = "gclid",
    salesforceContactId = "salesforceContactId",
    webConversion = "conversion-record",
}
